import { NAMESPACE } from "./_Namespace";
import { Constants } from "./Constants";
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { EntityCommandTeamsRebuildPermissions } from "./EntityCommandTeamsRebuildPermissions";
import { PartialNullable } from "./Extensions";
import { Property } from "./RadObject";
import { OrEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/OrEvaluator";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { TeamEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/TeamEvaluator";

export type EntityCommandUsersRebuildPermissionsPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandUsersRebuildPermissionsProperties = {
    [name in keyof EntityCommandUsersRebuildPermissionsPropertyValues]: Property<EntityCommandUsersRebuildPermissionsPropertyValues[name]>
};

export interface IEntityCommandUsersRebuildPermissions extends IEntityCommand, EntityCommandUsersRebuildPermissionsProperties
{
}

export class EntityCommandUsersRebuildPermissions extends EntityCommand<EntityCommandUsersRebuildPermissionsPropertyValues> implements IEntityCommandUsersRebuildPermissions
{
    public static override classNamespace = NAMESPACE + "EntityCommandUsersRebuildPermissions";
    public static override className = "EntityCommandUsersRebuildPermissions";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandUsersRebuildPermissionsPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Rebuild Permissions",
                entityName: "User",
                key: "USER_REBUILD_PERMISSIONS",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
                visibleEvaluator: new OrEvaluator({ evaluators: [new TeamEvaluator({ teamName: Constants.TeamNames.SYSTEM_ADMINISTRATORS }), new TeamEvaluator({ teamName: Constants.TeamNames.ADMINISTRATION_SYSTEM_USERS })] }),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandUsersRebuildPermissionsPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        await super._executeAsync(entityCommandInformation, value);
        await EntityCommandTeamsRebuildPermissions.rebuildPermissionsAsync();
    }

    // #endregion

    // #endregion
}

